'use strict';

/**
 * Wrap tables in a container div to make them scrollable when needed
 *
 * @param {object} options - Options to be used
 * @param {NodeList} options.tables - NodeList of the table(s) to wrap
 * @param {string} options.tableWrapperClass - table wrapper class name
 */
export function wrapTable(options) {
  if (!options || !options.tables) {
    return;
  }

  const tableWrapperClass = options.tableWrapperClass || '';

  options.tables.forEach(table => {
    const wrapper = document.createElement('div');
    wrapper.className = tableWrapperClass;
    table.parentNode.insertBefore(wrapper, table);
    wrapper.appendChild(table);
  });
}

/**
 * Wrap iframes in a container div to make them responsive
 *
 * @param {object} options - Options to be used
 * @param {NodeList} options.iframes - NodeList of the iframe(s) to wrap
 * @param {string} options.iframeWrapperClass - class name used on the wrapping div
 */
/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap iframes and tables in div tags to force responsive/scrollable layout.
 *
 */
export function wrapIframe(options) {
  if (!options || !options.iframes) {
    return;
  }

  const iframeWrapperClass = options.iframeWrapperClass || '';

  options.iframes.forEach(iframe => {
    const wrapper = document.createElement('div');
    wrapper.className = iframeWrapperClass;
    iframe.parentNode.insertBefore(wrapper, iframe);
    wrapper.appendChild(iframe);

    // Re-set the src attribute on each iframe after page load
    // for Chrome's "incorrect iFrame content on 'back'" bug.
    // https://code.google.com/p/chromium/issues/detail?id=395791
    // Need to specifically target video and admin bar
    iframe.src = iframe.src;
  });
}